/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.base.platform.review

/**
 * Default implementation of [AppReviewManager].
 */
class AppReviewManagerImpl : AppReviewManager {
    override fun promptForReview() {
    }

    override fun promptForCustomReview() {
        // TODO:: Implement custom review flow
    }
}
